(ns assemble.assets-page.drawer.assets
  (:require ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            [assemble.component.drawer.hooks :as dh]
            [assemble.component.drawer.view :refer [drawer]]
            [assemble.component.move-modal.db :as move-modal.db]
            [assemble.resource.asset :as resource]
            [assemble.util :as util]
            [clojure.string :as str]
            [common.resource.query.user :as uq]
            [common.util :refer [format-iso-string]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.preview-container :refer [preview-container]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(defui no-preview-container [{:keys [children]}]
  ($ Grid
     {:container true
      :sx #js {:height "200px"
               ;; This was #7A7A7A in the Figma
               :bgcolor "grey.50"
               ;; #D3D3D3 in Figma
               :color "grey.40"
               :borderRadius "4px"
               :fontWeight "600"
               :alignContent "center"
               :justifyContent "center"}}
     children))

(defui image-preview [{url :children}]
  ;; in order to center the image asset, we need to know the width. so we load the image with default
  ;; width and height, then adjust after the image is loaded and we know the actual values
  ;; height is set to 200, width is initially set relative to 16:9
  (let [[w set-w] (uix/use-state 356)
        h 200]
    ($ preview-container {:width w
                          :height h
                          :preview ($ :img {:src url
                                            :on-load #(set-w (.-offsetWidth (.-target %)))
                                            :height h})})))

(defui preview-view [{:asset/keys [name key-url mime-type]}]
  (let [{:keys [use-preview icon]} (util/get-file-type-parameters name)
        preview (case use-preview
                  ;; TODO: Implement new font preview for font files.
                  :img ($ image-preview key-url)
                  :video ($ :video
                            {:src key-url
                             :controls true
                             :height 200
                             ;; TODO: Add thumbnail
                             ;; :poster "url"
                             :style #js {;; Ensure video with wide aspect-ratio doesn't
                                         ;; use more width than the container.
                                         :width "100%"}})
                  nil)]
    ($ Grid
       {:container true
        :justifyContent "center"
        :size #js {:xs 12}}
       (if (and preview (not (util/unsupported-mime-type? mime-type)))
         preview
         ($ no-preview-container
            (if icon
              ($ Icon
                 {:sx #js {:fontSize "8rem"}}
                 icon)
              "No preview available"))))))

(defui asset-details [{:asset/keys [id mime-type key-url file-size dimensions created-by created-at]}]
  (let [{:keys [subtype]} (util/split-mime-type mime-type)
        username (uq/use-user-id->user-name created-by)]
    ($ :<>
       ($ form-field
          {:label "URL"
           :sx #js {:width "100%"
                    :overflow "hidden"}}
          ($ Stack {:direction "row" :gap 1 :alignItems "center"}
             ($ Tooltip
                {:placement :bottom
                 :title "Copy to clipboard"}
                ($ IconButton
                   {:onClick #(rf/dispatch [:assemble.assets-page/copy-to-clipboard key-url])
                    :sx #js {:padding 0}}
                   ($ Icon "content_copy")))
             ($ Link
                {:href key-url
                 :noWrap true
                 :target "_blank"
                 :onClick (fn [^js e]
                            (set! (.-ignore e) true))}
                key-url)))

       ($ form-field
          {:label "File type"}
          (if (util/unsupported-mime-type? mime-type)
            "Unsupported file type"
            ($ Typography
               {:textTransform "uppercase"}
               subtype)))

       ($ form-field
          {:label "File size"}
          (util/format-file-size file-size))

       (when (and dimensions (not (str/starts-with? mime-type "audio")))
         ($ form-field
            {:label "Dimensions"}
            dimensions))

       ($ form-field
          {:label "ID"}
          (str id))

       ($ Divider)

       ($ form-field
          {:label "Owner"}
          username)

       ($ form-field
          {:label "Created"}
          (format-iso-string created-at "LL")))))

(defui assets-drawer []
  (let [{:asset/keys [id name asset-tree-id archived] :as data} (dh/use-drawer-assets-data)
        open? (dh/use-drawer-open? :file)
        on-close #(rf/dispatch [:assemble.assets-page/drawer-close])]
    ($ drawer
       {:name (when (some? (:asset/name data))
                (util/basename (:asset/name data)))
        :drawer-type-label "asset"
        :detail-view ($ asset-details data)
        :preview-view ($ preview-view data)
        :open? open?
        :on-archive (fn []
                      (js/Promise. (fn [resolve reject]
                                     (rf/dispatch [::resource/archive-asset resolve reject id (not archived)]))))
        :archived? archived
        :on-move #(rf/dispatch [::move-modal.db/open {:item-id id
                                                      :item-name name
                                                      :folder-id asset-tree-id}])
        :on-rename (fn [new-value]
                     (js/Promise. (fn [resolve reject]
                                    (let [extension (util/file-extension name)
                                          value-with-extension (str new-value "." extension)]
                                      (rf/dispatch [::resource/rename-asset resolve reject id value-with-extension])))))
        :on-close on-close})))
